// extracted by mini-css-extract-plugin
module.exports = {"container":"paper-module__container--PTTbk","level":"paper-module__level--2cg7x"};